export enum InteractionTrigger {
  KEYBOARD_SHORTCUT = 'KEYBOARD_SHORTCUT',
  /** Format-as-you-type. */
  KEYBOARD_TYPING = 'KEYBOARD_TYPING',
}

export enum InteractionAction {
  SET_UPPERCASE = 'SET_UPPERCASE',
  TOGGLE_BOLD = 'TOGGLE_BOLD',
  TOGGLE_ITALIC = 'TOGGLE_ITALIC',
  TOGGLE_UNDERLINE = 'TOGGLE_UNDERLINE',
  TOGGLE_STRIKETHROUGH = 'TOGGLE_STRIKETHROUGH',
  SET_BLOCKQUOTE = 'SET_BLOCKQUOTE',
  SET_UNORDERED_LIST = 'SET_UNORDERED_LIST',
  SET_ORDERED_LIST = 'SET_ORDERED_LIST',
  SET_LINK = 'SET_LINK',
  SET_INLINE_CODE = 'SET_INLINE_CODE',
  SET_CODE_BLOCK = 'SET_CODE_BLOCK',
}

export interface InteractionEvent {
  trigger: InteractionTrigger;
  action: InteractionAction;
}

export type InteractionHandler = (event: InteractionEvent) => void;
